import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MegamenuComponent } from '../megamenu/megamenu.component';
import { FooterComponent } from '../footer/footer.component';
import { CompanyConfigService, CompanyConfig } from '../../services/company-config.service';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrl: './terms-of-service.component.css',
  imports: [
    CommonModule,
    MegamenuComponent,
    FooterComponent
  ]
})
export class TermsOfServiceComponent {
  config: CompanyConfig;

  constructor(private companyConfig: CompanyConfigService) {
    this.config = this.companyConfig.getConfig();
  }
}